import * as SensorsTriM from '@assets/icons/44x44/sensor';
import * as SensorsTriL from '@assets/icons/64x64/sensor';
import { Center, Icon } from '@chakra-ui/react';
import { extendedSensorShortHand } from '@utils/map/map.constants';
import { capitalize } from 'lodash';

import { ExtendedSensor } from '@/types/sensor/sensors';

interface Props {
  type: ExtendedSensor;
  size?: 'M' | 'L';
}

function SensorTrigram({ type, size = 'M' }: Readonly<Props>) {
  const isMedium = size === 'M';
  const sensorTrigramName = capitalize(extendedSensorShortHand[type]) as SensorsTriM.SensorTrigramKeys;
  const IconComponent = isMedium ? SensorsTriM[sensorTrigramName] : SensorsTriL[sensorTrigramName];

  if (typeof IconComponent !== 'function' && typeof IconComponent !== 'object') {
    console.error(`No valid component for key "${sensorTrigramName}".`);
    return null;
  }

  return (
    <Center boxSize={isMedium ? '48px' : '64px'}>
      <Icon as={IconComponent} boxSize={isMedium ? '44px' : '64px'} />
    </Center>
  );
}

export default SensorTrigram;
